import axiosCilent from "./axiosClient";
import { Result } from "../model/Result";
import { EncryptedKey, Keys } from "../model/Keys";
import { auth } from "../firebase";
import jwtApi from "./Jwt.api";

export const requestPasswordDecrypto = async (keys: Keys[], tenantId: string): Promise<Result> => {
  try {
    const currentUser = auth.currentUser;
    return await jwtApi.requestGetJwt(currentUser?.email!, currentUser?.uid!, currentUser?.tenantId!)
      .then(async (_) => {
        const response = await axiosCilent.post(`decrypto/${tenantId}`, keys);
        return response.data;
      })
      .catch((rejects) => {
        return {success: false, data: rejects};
      });
  } catch (error) {
    return Promise.reject({ success: false, error });
  }
};

export const requestPasswordEncrypto = async (keys: EncryptedKey[], tenantId: string): Promise<Result> => {
  try {
    const currentUser = auth.currentUser;
    return await jwtApi.requestGetJwt(currentUser?.email!, currentUser?.uid!, currentUser?.tenantId!)
      .then(async (_) => {
        const response = await axiosCilent.post(`encrypto/${tenantId}`, keys);
        return response.data;
      })
      .catch((rejects) => {
        return {success: false, data: rejects};
      });
  } catch (error) {
    return Promise.reject({ success: false, error });
  }
};
// helper functions
